import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Flex, Box } from "@chakra-ui/react";
import { FilterPaymentDetailProps, IFilterPaymentDetail } from "./interface";
import FieldSearch from "../FieldSearch";

const Filter: React.FC<FilterPaymentDetailProps> = ({ onSubmit, value }) => {
  const { handleSubmit, setValue, control } = useForm<IFilterPaymentDetail>();

  useEffect(() => {
    setValue("key", value?.key || "");
  }, [value, setValue]);

  return (
    <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
      <Flex alignItems="center" gap={4}>
        <Box>
          <Controller
            name="key"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FieldSearch
                placeholder="Search Payment Detail"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        </Box>
      </Flex>
    </form>
  );
};

export default Filter;
